export enum OrganizationAccess {
  FullView = 0,
  AssignedOnly = 1,
}
